var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvelte = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "-26 0 308 308",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ff3e00",
  d: "M240 41a94 94 0 0 0-126-27L42 59a82 82 0 0 0-37 55 87 87 0 0 0 9 56 82 82 0 0 0-13 31 88 88 0 0 0 15 66c29 41 85 53 126 27l72-46a82 82 0 0 0 37-55 87 87 0 0 0-9-55 82 82 0 0 0 13-31 88 88 0 0 0-15-66"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M107 271c-23 6-48-3-61-23a53 53 0 0 1-9-40l1-6 2-4 4 2a93 93 0 0 0 28 14l2 1v3l3 10a17 17 0 0 0 18 7l5-2 71-45a15 15 0 0 0 7-10 16 16 0 0 0-3-12 17 17 0 0 0-18-7l-4 2-28 17-14 7c-23 6-48-4-61-23a53 53 0 0 1-9-40 49 49 0 0 1 22-33l72-46 14-6c23-6 48 3 61 22a53 53 0 0 1 9 40l-1 7-2 4-4-3a92 92 0 0 0-28-14h-2v-3a16 16 0 0 0-3-11 17 17 0 0 0-18-7l-5 2-71 46a15 15 0 0 0-7 10 16 16 0 0 0 3 12 17 17 0 0 0 18 7l4-2 28-17 14-7c23-6 48 3 61 23a53 53 0 0 1 9 40 49 49 0 0 1-22 33l-72 45z"
})));
export default SvgSvelte;